import { useEffect, useState } from 'react';

import StatementOfCashFlowScreen from '../StatementOfCashFlow/Screens/StatementOfCashFlowScreen';
import moment from 'moment';
import { useCashFlowQuery } from './const';
import useNavActive from '../../components/Navbar/useNavActive';
import { toast } from 'react-toastify';
import { getCashFlowExport } from '../../api/statementOfCashFlow';
const defaultForm = {
  date_from: moment().startOf('month').format('YYYY-MM-DD'),
  date_to: moment().endOf('month').format('YYYY-MM-DD'),
  bank_id: [],
  random: Math.random(),
};

export const StatementOfCashFlow = () => {
  useNavActive([
    'finance_and_accounting',
    'fna_financial_reports',
    'cashflow_cib',
  ]);

  const [form, setForm] = useState(defaultForm);
  const [tableParams, setTableParams] = useState(defaultForm);
  const [banks, setBanks] = useState([]);

  const { isFetching, data } = useCashFlowQuery(tableParams);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });

    // console.log(form);
  };

  const handleSearch = () => {
    setTableParams({
      ...tableParams,
      ...form,
      bank_id: form.bank_id.map((row) => row.value),
      random: Math.random(),
    });
  };

  const handleExport = async () => {
    try {
      toast.loading('Please wait....');
      const res = await getCashFlowExport(tableParams);

      const { code, result } = res.data.response;

      toast.dismiss();
      if (code !== '00000') {
        throw new Error(result);
      }

      window.location.href = result;
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  return (
    <>
      <StatementOfCashFlowScreen
        tableData={data}
        isLoading={isFetching}
        form={form}
        banks={banks}
        onChange={handleChange}
        onSearch={handleSearch}
        onExport={handleExport}
      />
    </>
  );
};
